import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const PageHeaderContainer = styled.div`
    display: flex;
    align-items: center;

    h1 {
        margin-right: ${Spacing.SM}px;
    }

    .folder-selection {
        flex-grow: 0;
        margin-right: ${Spacing.SM}px;
    }
`;
